import request from '../utils/request.js';

// 标签类别
export const getMainMenu = () => {
    return request({
        url: '/api/content/v1/category/main-menu',
        method: 'get',
    });
};

// 获取所有游戏
export const getAllGames = (params, propController) => {
    return request({
        url: '/api/content/v1/game/get-all',
        method: 'get',
        params,
        propController,
    });
};

// 获取相似游戏
export const getSimilarGames = (params) => {
    return request({
        url: '/api/content/v1/game/get-all-by-similar',
        method: 'get',
        params,
    });
};

// 按游戏类型获取
export const getCategoryGame = (params) => {
    return request({
        url: '/api/content/v1/game/get-all-by-t-c',
        method: 'get',
        params,
    });
};

// 获取游戏封面
export const getGameCover = (params) => {
    return request({
        url: '/api/content/v1/photo/games-cover',
        method: 'get',
        params,
    });
}

// 获取单个游戏详情
export const getGameDetail = (params) => {
    return request({
        url: '/api/content/v1/category/get-all-by-game',
        method: 'get',
        params,
    })
};

// 点击事件埋点
export const clickEvent = (params) => {
    return request({
        url: '/api/content/v1/event/add',
        method: 'post',
        params,
    })
}